import OpenOnClick, { Props } from './OpenOnClick';

export default OpenOnClick;
export { type Props };